import { validateDiscoveryButtons } from './discoveryButtonsValidation';
import { resolveExportImageUrls } from './botBucketImageUrls';

const EXCLUDED_KEYS = new Set([
  'botUrl',
  'isDesignPreview',
  'baseApiUrl',
  'botApi',
  'authInPopup',
  'autoLogin',
  'nonAuthTextAdmin',
  'projectsConfig',
  'bots',
  'loadLastSession',
  'defaultBot',
  'urlClickText',
]);

export function parseDiscoveryJson(discoveryJson) {
  if (discoveryJson == null) {
    return { ok: true, value: null };
  }

  try {
    const parsed = JSON.parse(discoveryJson || '[]');
    if (!Array.isArray(parsed)) {
      return { ok: false, error: 'חייב להיות מערך JSON' };
    }
    return validateDiscoveryButtons(parsed);
  } catch {
    return { ok: false, error: 'JSON לא תקין' };
  }
}

export function migrateStoredDraft(stored, baseDraft) {
  if (!stored || typeof stored !== 'object') {
    return { draft: baseDraft, migrated: false };
  }

  let nextDraft = baseDraft;
  let migrated = false;

  if (stored.payload && typeof stored.payload === 'object') {
    nextDraft = mergeDraftWithPayload(baseDraft, stored.payload);
    migrated = true;
  }

  if (stored.discoveryJson != null && stored.discoveryJson !== '') {
    const legacy = parseDiscoveryJson(stored.discoveryJson);
    if (legacy.ok && Array.isArray(legacy.value)) {
      nextDraft = {
        ...nextDraft,
        discoveryButton: legacy.value,
      };
      migrated = true;
    }
  }

  return { draft: nextDraft, migrated };
}

export function buildAdminPayload(draft) {
  if (!draft || typeof draft !== 'object') {
    return {};
  }

  const working = JSON.parse(JSON.stringify(draft));
  delete working.botUrl;
  delete working.isDesignPreview;

  const payload = {};
  Object.entries(working).forEach(([key, value]) => {
    if (!EXCLUDED_KEYS.has(key)) {
      payload[key] = value;
    }
  });

  return payload;
}

export function buildExportPayload(draft, { botName, domainName }) {
  const payload = buildAdminPayload(draft);
  return resolveExportImageUrls(payload, { botName, domainName, draft });
}

export function mergeDraftWithPayload(baseDraft, payload) {
  if (!payload || typeof payload !== 'object') {
    return baseDraft;
  }

  return {
    ...baseDraft,
    ...payload,
    theme: {
      ...baseDraft.theme,
      ...payload.theme,
      colors: {
        ...baseDraft.theme?.colors,
        ...payload.theme?.colors,
      },
    },
    botUrl: baseDraft.botUrl,
    isDesignPreview: baseDraft.isDesignPreview,
  };
}
